import { useQuery } from 'react-query';
import { ChannelController } from '@services/apiClient/interfaces/ChannelController';

export const useConfiguration = ({ channel }) =>
  useQuery(['configuration', { channel }], () => ChannelController.getConfiguration({ channel }), {
    staleTime: Infinity,
  });
